import React from "react";

const getTokenType = (
  token: string,
): "url" | "bold" | "italic" | "strike" | "mono" | "text" => {
  if (/^https?:\/\//i.test(token)) return "url";
  if (/^\*[^*\n]+\*$/.test(token)) return "bold";
  if (/^_[^_\n]+_$/.test(token)) return "italic";
  if (/^~[^~\n]+~$/.test(token)) return "strike";
  if (/^`[^`\n]+`$/.test(token)) return "mono";
  return "text";
};

interface ActivityRichTextProps {
  text?: string | null;
  className?: string;
  emptyText?: string;
}

export const ActivityRichText: React.FC<ActivityRichTextProps> = ({
  text,
  className,
  emptyText,
}) => {
  const value = (text || "").trim();

  if (!value) {
    if (!emptyText) return null;
    return <span className={className}>{emptyText}</span>;
  }

  const lines = value.split("\n");

  return (
    <span className={className}>
      {lines.map((line, lineIndex) => {
        const parts = line.split(
          /(https?:\/\/[^\s]+|\*[^*\n]+\*|_[^_\n]+_|~[^~\n]+~|`[^`\n]+`)/g,
        );

        return (
          <React.Fragment key={`line-${lineIndex}`}>
            {parts.map((part, partIndex) => {
              if (!part) return null;

              const type = getTokenType(part);
              const key = `token-${lineIndex}-${partIndex}`;

              if (type === "url") {
                return (
                  <a
                    key={key}
                    href={part}
                    target="_blank"
                    rel="noreferrer"
                    className="underline break-all"
                  >
                    {part}
                  </a>
                );
              }

              if (type === "bold") {
                return <strong key={key}>{part.slice(1, -1)}</strong>;
              }

              if (type === "italic") {
                return <em key={key}>{part.slice(1, -1)}</em>;
              }

              if (type === "strike") {
                return <s key={key}>{part.slice(1, -1)}</s>;
              }

              if (type === "mono") {
                return (
                  <code
                    key={key}
                    className="px-1 rounded bg-black/10 text-[0.92em]"
                  >
                    {part.slice(1, -1)}
                  </code>
                );
              }

              return <React.Fragment key={key}>{part}</React.Fragment>;
            })}
            {lineIndex < lines.length - 1 && <br />}
          </React.Fragment>
        );
      })}
    </span>
  );
};
